export default "__VITE_ASSET__DovZyLlW__";